import React, {useState, useEffect, useContext} from 'react';
import Navbar1 from './Navbar1';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
    doc,
    getDoc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from 'react-toastify';
import { reset } from '../../features/auth/authSlice';
import { AuthContext } from "../../context/AuthContext";
import Spinner from '../../components/Spinner'
import Sidebar from './Sidebar';

const titles = [
    {
      label: "Mr.",
      value: "Mr.",
    },
    {
      label: "Mme",
      value: "Mme",
    },
    {
      label: "Dr.",
      value: "Dr.",
    },
    {
      label: "Pr.",
      value: "Pr.",
    },
  ];

const grades = [
    {
      label: "AR",
      value: "AR",
    },
    {
      label: "CR",
      value: "CR",
    },
    {
      label: "MR",
      value: "MR",
    },
    {
      label: "DR",
      value: "DR",
    },
  ];
let id = '';
const Step0 = () => {
    let email = "Votre email";
    var today = Date();
    var lastDay = '01/30/2023';
    const {currentUser} = useContext(AuthContext);
    const { t } = useTranslation();
    const type = localStorage.getItem("type");
    if(currentUser != null){
        email = currentUser.email;
    }
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const [page, setUpdated] = useState({
        updated: true,
    });

    const [status, setEnabled] = useState({
        submitted: false,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });

    const handleTitleChange = (e) => {
        title1.title = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setTitle({...title1, [title1]:e.target.value})
    }

    // Handle Input
    const handleGradeChange = (e) => {
        grade1.grade = e.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setGrade({...grade1, [grade1]:e.target.value})
    }

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [title1, setTitle] = useState({
        title: 'Mr.',
    });

    const [grade1, setGrade] = useState({
        grade: 'AR',
    });

    const [user, setUser] = useState({
        id: '',
        title : '',
        grade : '',
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        whatsapp: ''
    });
    
    const getStatus = async () => {
        try {
            const userRef = doc(db, "submissions", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
                status.submitted = true;
                setEnabled({...status, [status]:true})
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    const getUserDetails = async () => {
        try {
            const userRef = doc(db, "users", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
            return userSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
        }
    };

    const { usr, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )
    
    

    useEffect(() => {
        // restrict access for examinators
        if(type === 'exam'){
            navigate('/admin')
        }
        
        // getting user details
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);

            getStatus();
            getUserDetails().then(data => {
                if(data != null){
                    //user = data;
                    setUser(data);
                    localStorage.setItem('firstName', data.firstName);
                    setFirstRender(false);
                }
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || usr) {
            navigate("/step1")
        }
        dispatch(reset())
  }, [user, title1, grade1, isError, isSuccess, message, firstRender, dispatch])

    // Handle Input
    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        setUser({...user, [name]:value})
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        if(window.confirm("Enregistrer les modifications ?")){
            setIsLoading(true);
            let {title, grade, lastName, firstName, email, phone, whatsapp} = user;
            title = title1.title;
            grade = grade1.grade;
            const userUpdate = {
                id,
                title,
                grade,
                lastName,
                firstName,
                email,
                phone,
                whatsapp
            }
            try {
                await setDoc(doc(db, "users", id), {
                ...userUpdate,
                timeStamp: serverTimestamp(),
                });
                localStorage.setItem('user', JSON.stringify(userUpdate))
                navigate("/step1");
            } catch (error) {
                setIsLoading(false);
                if(error.toString().includes("offline")){
                    window.alert('Pas de connexion internet')
                }
                else{
                    window.alert(error)
                }
            }
        }
    }

    if (isLoading) {
        return <Spinner />
      }

    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                <div className='col-md-3 m-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">{t('application')}</p>
                            <div className="m-3 mt-0 mb-0">
                                <Sidebar />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 pl-4">
                        <p className="lead fs-1">{t('menu_0')}</p>
                        <p className="col-md-8">{t('step_0_text_1')}.</p>
                        <p><span className="star">*</span> = {t('required')}</p>
                        <form onSubmit={handleSubmit}>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="titles" class="form-label me-4"><span className="star">*</span>{t('title')}</label>
                                        <select value={title1.title} disabled={status.submitted || deadline.value <= 0} onChange={handleTitleChange}>
                                            {titles.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="grades" class="form-label"><span className="star">*</span>Grade</label>
                                        <select value={grade1.grade} disabled={status.submitted || deadline.value <= 0} onChange={handleGradeChange} required>
                                            {grades.map((option) => (
                                            <option value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="lastNameInput" class="form-label"><span className="star">*</span>{t('names')}</label>
                                    <input type="text" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="lastName" aria-describedby="emailHelp"
                                    name="lastName" value ={user.lastName} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span>{t('first_names')}</label>
                                    <input type="text" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="firstName" value ={user.firstName} onChange={handleInput}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span>{t('email_address')}</label>
                                    <input type="email" required disabled={status.submitted || deadline.value <= 0} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    name="email" value ={user.email ?? email} onChange={handleInput}/>
                                </div>
                                <div className="d-flex justify-content-start">
                                    <div className="mb-3 me-4">
                                        <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span>{t('phone')}</label>
                                        <input type="phone" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="phone" required disabled={status.submitted || deadline.value <= 0} value ={user.phone} onChange={handleInput}/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span>Whatsapp</label>
                                        <input type="phone" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="whatsapp" required disabled={status.submitted || deadline.value <= 0} value ={user.whatsapp} onChange={handleInput}/>
                                    </div>
                                </div>
                                <button type="submit" disabled={status.submitted || deadline.value <= 0} class="btn btn-outline-primary mt-4">{t('start')}</button>
                        </form>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Step0;
